module.exports = __webpack_public_path__ + "static/media/header-back.f5589c75.jpg";